<template>
  <div class="company-profile">
    <div class="brief">
      <div class="avatar"><img src="@/assets/image/companyProfile/avator-wisely.png"></div>
      <div class="name">{{ $t('name') }}</div>
      <div class="title">{{ $t('title') }}</div>
    </div>
    <div class="detail">
      <div class="icon-quote"><img src="@/assets/image/icons/icon-quote.png"></div>
      <div class="desc">{{$t('desc')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        name: 'Wisely Reinharda Wijaya',
        title: 'President Director',
        desc: 'Wisely is the President Director in Kredit Pintar. He has a Bachelor of Material Science and Engineering which he obtained from Beihang University. His interest in the development of the fintech industry encouraged him start PT Kredit Pintar Indonesia. In his position and with his competence, Wisely has a view to advance the Indonesian economy by making Kredit Pintar a solution for financial inclusion in Indonesia.',
      },
      id: {
        name: 'Wisely Reinharda Wijaya',
        title: 'Direktur Utama',
        desc: 'Wisely merupakan Direktur Utama di Kredit Pintar. Dirinya memiliki gelar Bachelor of Material Science and Engineering yang di dapatnya dari Beihang University. Ketertarikannya di perkembangan dunia fintech membuatnya memulai PT Kredit Pintar Indonesia. Dalam jabatannya dan dengan kompetensinya yang mumpuni, Wisely memiliki pandangan untuk memajukan perekonomian Indonesia dengan menjadikan Kredit Pintar sebagai solusi keuangan infklusif di Indonesia.',
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="stylus" scoped>
.company-profile {
  padding: 42px 35px 20px;
}

.brief {
  text-align: center;
  .avatar {
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .name {
    font-size: 11px;
    margin-bottom: 5px;
  }
  .title {
    font-size: 12px;
    color: #7CC633;
    font-weight: bold;
    margin-bottom: 16px;
  }
}

.detail {
  .icon-quote img{
    width: 26px;
    height: 26px;
    margin-bottom: 4px;
  }
  .desc {
    padding: 0 10px;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
